import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import {Button, Card} from "react-bootstrap";
import Logo from '../../Components/Navigation/logo_g1.png';
import BlogReader from "../../Components/Blog/BlogReader";

function SocietyPage() {
    return (<>
        <Navbar/>
        <Card>
            <Card.Header>Der Verein</Card.Header>
            <Card.Body>
		<Card.Text>
                ... mehr als nur die Summe seiner Mitglieder!
                </Card.Text>
                
                <div className="d-flex justify-content-center">
                    <img
                        src={Logo}
                        alt="Logo"
                        style={{width: "15%"}}
                    />
                </div>
		<Card.Text>
                Der TSC Stahl Hennigsdorf e.V. wurde im März 1990 von 35 Mitgliedern der ehemaligen Sektion Tauchsport der GST - Grundorganisiation des Stahlwerkes Hennigsdorf gegründet. Damit wurde eine zu diesem Zeitpunkt ca. 25-jährige Tradition des Sporttauchens in Hennigsdorf fortgesetzt.
			    
                Wir sind ein aktiver und aufgeschlossener Tauchverein in Hennigsdorf direkt an der Stadtgrenze von Berlin. Momentan sind wir ca. 100 Mitglieder im Alter von 8 bis 88 Jahren. Teilweise haben ganze Familien mit mehreren Generationen Spaß an unserem tollen und naturnahen Hobby sowie anderen gemeinsamen Aktivitäten.
                </Card.Text>
                
            </Card.Body>
        </Card>

        <Card className="impressum">
            <Button variant="Link" href="/impressum">Impressum</Button>
        </Card>
    </>)

}

export default SocietyPage;
